<template>
  <div class="return">
    <sidebar_user :setorders="orders" />
    <section class="home-section">
      <div class="space"></div>
      <b-container>
        <div class="wrapper" v-if="!chk_auth">
          <div class="card_">
            <div class="img">
              <img src="../../assets/logos/icon-logo.png" alt="" />
            </div>
            <h1><b>โปรดเข้าสู่ระบบ </b></h1>
            <h5 class="text-white">ก่อนคืนหนังสือค่ะ</h5>
            <label>
              <!-- <i class="fa-solid fa-map-location-dot"></i> -->
              <button class="btn btn-orange btn-block" @click="login()">
                เข้าสู่ระบบ
              </button>
            </label>
          </div>
        </div>
        <span v-if="chk_auth">
          <div class="card-columns" >
            <div
              class="card card-order-list card-margin border-0 card-scanbarcode"
            >
              <div class="card-body">
                <div class="row">
                  <div class="col-lg-6 col-md-6 col-sm-6">
                    <div class="wrapper" v-if="!isNear">
                      <div class="card_">
                        <div class="img">
                          <img src="../../assets/icons/google-maps.png" alt="" />
                        </div>
                        <h1>
                          <b>คุณอยู่ห่าง {{ distance * 1000 }} เมตร</b>
                        </h1>
                        <h5 class="text-white">UBRU Happiness coffee</h5>
                        <label>
                          <!-- <i class="fa-solid fa-map-location-dot"></i> -->
                          <span
                            @click="showMore('happyness')"
                            v-if="!readMore['happyness']"
                            >คลิก</span
                          >
                          <span
                            @click="showLess('happyness')"
                            v-if="readMore['happyness']"
                            >ปิด</span
                          >
                        </label>
  
                        <!-- <label>
                        <input type="checkbox" />
                        <span><i class="fas fa-chevron-down"></i></span>
                        <div class="socialicon">
                          <ul>
                            <li>
                              <a href="#">
                                <i class="fab fa-facebook-f"></i>
                              </a>
                            </li>
              
                            <li>
                              <a href="#">
                                <i class="fab fa-twitter"></i>
                              </a>
                            </li>
              
                            <li>
                              <a href="#">
                                <i class="fab fa-instagram"></i>
                              </a>
                            </li>
                          </ul>
                        </div>
                      </label> -->
                      </div>
                    </div>
                    <div class="wrapper" v-if="isNear">
                      <div class="card_isNear">
                        <div class="img">
                          <img src="../../assets/icons/google-maps.png" alt="" />
                        </div>
                        <h1><b>ถึงแล้ว</b></h1>
                        <h5 class="text-white">UBRU Happiness coffee</h5>
                        <label>
                          <!-- <i class="fa-solid fa-map-location-dot"></i> -->
                          <!-- <span @click="showMore('happyness')" v-if="!readMore['happyness']">คลิก</span>
                        <span @click="showLess('happyness')" v-if="readMore['happyness']">ปิด</span> -->
                        </label>
                      </div>
                    </div>
                    <span class="happiness-cafe" v-if="readMore['happyness']">
                      <br />
                      <iframe
                        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3849.4019508447727!2d104.84436797605323!3d15.24586046095168!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x31168700199efc39%3A0x5433b2153744de00!2sUBRU%20Coffee%20Happiness%20Club!5e0!3m2!1sth!2sth!4v1719197274049!5m2!1sth!2sth"
                        width="100%"
                        height="450"
                        style="border: 0"
                        allowfullscreen=""
                        loading="lazy"
                        referrerpolicy="no-referrer-when-downgrade"
                      ></iframe>
                    </span>
                    <br />
                  </div>
                  <div class="col-lg-6 col-md-6 col-sm-6">
                    <div class="wrapper" v-if="!swatNear">
                      <div class="card_">
                        <div class="img">
                          <img src="../../assets/icons/google-maps.png" alt="" />
                        </div>
                        <h1>
                          <b>คุณอยู่ห่าง {{ distanceSawat * 1000 }} เมตร</b>
                        </h1>
                        <h5 class="text-white">UBRU coffee - สวัสดิการ</h5>
                        <label>
                          <span
                            @click="showMore('sawat')"
                            v-if="!readMore['sawat']"
                            >คลิก</span
                          >
                          <span
                            @click="showLess('sawat')"
                            v-if="readMore['sawat']"
                            >ปิด</span
                          >
                        </label>
                      </div>
                    </div>
                    <div class="wrapper" v-if="swatNear">
                      <div class="card_isNear">
                        <div class="img">
                          <img src="../../assets/icons/google-maps.png" alt="" />
                        </div>
                        <h1><b>ถึงแล้ว</b></h1>
                        <h5 class="text-white">UBRU coffee - สวัสดิการ</h5>
                        <label>
                          <!-- <i class="fa-solid fa-map-location-dot"></i> -->
                          <span
                            @click="showMore('happyness')"
                            v-if="!readMore['happyness']"
                            >คลิก</span
                          >
                          <span
                            @click="showLess('happyness')"
                            v-if="readMore['happyness']"
                            >ปิด</span
                          >
                        </label>
                      </div>
                    </div>
                    <span class="sawat-cafe" v-if="readMore['sawat']">
                      <iframe
                        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3849.3987609729447!2d104.84584517605319!3d15.246034660947123!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3116878d3f9783f3%3A0x515de3d4404bc7ce!2z4Lij4LmJ4Liy4LiZ4LiE4LmJ4Liy4Liq4Lin4Lix4Liq4LiU4Li04LiB4Liy4LijIOC4oeC4q-C4suC4p-C4tOC4l-C4ouC4suC4peC4seC4ouC4o-C4suC4iuC4oOC4seC4j-C4reC4uOC4muC4peC4o-C4suC4iuC4mOC4suC4meC4tQ!5e0!3m2!1sth!2sth!4v1719201164783!5m2!1sth!2sth"
                        width="100%"
                        height="450"
                        style="border: 0"
                        allowfullscreen=""
                        loading="lazy"
                        referrerpolicy="no-referrer-when-downgrade"
                      ></iframe>
                    </span>
                  </div>
                </div>
  
                <br />
              </div>
  
            </div>
          </div>
          <!-- END -->
          <div class="card-columns">
            <div  class="card card-order-list card-margin border-0 card-scanbarcode">
              <div class="card-body" v-show="showBarcode">
                <div class="card-columns">
                  <div class="card-title text-left">
                    <h5 class="text-primary" @click="showBarcode = !showBarcode">
                      <i class="fa-solid fa-arrow-left"></i> เสร็จสิ้น
                    </h5>
                    <!-- <button class="btn btn-info" @click="stopCameraStream()">
                      close
                    </button> -->
                  </div>
                  <div class="card-title">
                    <div v-if="!showBarcodeReturn">
                      <span class="pull-right">
                        <button
                          class="btn btn-outline-purple btn-floating"
                          @click="checkBarcode()"
                        >
                          สแกนไม่ได้ใช่ไหม?
                        </button>
                      </span>
  
                      <br />
                      <br />
                      <br />
  
                      <div
                        class="card card-order-list card-margin border-0 card-service"
                      >
                        <div class="card-body">
                          <StreamBarcodeReader
                            @decode="(a, b, c) => onDecode(a, b, c)"
                            @loaded="() => onLoaded()"
                          ></StreamBarcodeReader>
                        </div>
                        <!-- Return value: {{ String(boxTwo) }}
                        Input Value: {{ text || "Nothing" }} -->
                      </div>
                    </div>
                    <div v-if="showBarcodeReturn">
                      <span class="pull-right">
                        <button
                          class="btn btn-outline-purple btn-floating"
                          @click="checkBarcode()"
                        >
                          SCAN BARCODE
                        </button>
                      </span>
                      <br />
                      <br />
  
                      <div class="card-body">
                        <!-- <input type="text" value="" class="card-scanbarcode" placeholder="กรอกบาร์โค้หนังสือ"/> -->
                        <form action="" @submit.prevent="return_enter">
                          <div class="search">
                            <input
                              id="myInput"
                              type="text"
                              class="search__input"
                              placeholder="กรอกบาร์โค้ดหนังสือ"
                              style="border-radius: 20px"
                              pull-right
                              v-model="inputsearch"
                            />
  
                            <div class="search__icon">
                              <i class="fa-solid fa-barcode"></i>
                              <!-- <ion-icon name="search"></ion-icon> -->
                            </div>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                  <br />
  
                  <div class="card-columns">
                    <div
                      class="card card-order-list card-margin border-0 card-service"
                      v-for="(item, index) in data_loan_arr"
                      :key="index"
                    >
                      <div class="card-title text-left pt-3">
                        <b-row>
                          <b-col cols="5">
                            <h4>UBRUCoffee</h4>
                          </b-col>
                          <b-col cols="7" class="text-right">
                            <h4>คืนแล้ว: {{ item.TimeDue | moment }}</h4>
                          </b-col>
                        </b-row>
  
                        <b-row>
                          <b-col cols="12">
                            <h5>
                              <i class="fa-solid fa-book fa-1x"></i>
                              {{ item.Title }}
                            </h5>
                          </b-col>
                        </b-row>
  
                        <b-row>
                          <b-col cols="12">
                            <h5>
                              <i class="fa-solid fa-barcode"></i>
                              {{ item.Barcode }}
                            </h5>
                          </b-col>
                        </b-row>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
  
              <div class="card-body" v-show="!showBarcode">
                <br />
                <div class="card-columns">
                  <div
                    class="card card-order-list card-margin border-0 card-service"
                  >
                    <div class="card-title pt-3">
                      <h1>คืนหนังสือ</h1>
                      <h6>SCAN BARCODE</h6>
                    </div>
                  </div>
                </div>
                <br />
                <br />
  
                <img
                  src="../../assets/icons/barcode_1.png"
                  alt=""
                  class="barcode pt-4"
                />
                <br />
                <br />
                <br />
                <br />
                <button class="btn__" @click="showBarcode = !showBarcode">
                  SCAN BARCODE
                </button>
                <br />
                <br />
              </div>
            </div>
            <br />
          </div>
        </span>
        
        
      </b-container>
      <!-- ============================================= MODAL =====================================================================  -->

      <!-- ============================================== END =====================================================================-->
    </section>
  </div>
</template>

<script>
import sidebar_user from "../layouts/sidebar_user.vue";
import axios from "axios";
import { StreamBarcodeReader } from "vue-barcode-reader";
import CryptoJS from "crypto-js";
import moment from "moment";
import { getDistance } from "geolib";
export default {
  name: "ubrucoffee",
  components: { sidebar_user, StreamBarcodeReader },
  props: {
    msg: String,
  },
  data() {
    return {
      items: [],
      orders: [],
      user: false,
      token: "dQpojB8WkH7HAZdh223jaqFSB1x5RYoKBjU0BAaVZt8DTVaxO5Sx5DlsErA2Zsu",
      token_req:
        "Bh3kiVe6KDRfcm9L4nNGm33pPF42PkhBB3Ft2GX7fcuvPQMh2YkTS3pV7JZMwCnIK",
      auth: [],
      books: [],
      text: "",
      chk_auth: true,
      id: null,
      showBarcode: "",
      showBarcodeReturn: false,
      showInput: "",
      secret_one: "",
      keycomponent: "",
      datas: "",
      data: [],
      data_loan: [],
      data_loan_arr: [],
      data_loan_object: [],
      return_arr: [],
      text_return: "",
      inputsearch: "",
      userLocation: null,
      sawatLocation: null,
      // 15.246659546231337, 104.84898160604143 ห้องสมุด
      // 15.24586046095168 ,104.84436797605323 ,15.2458566,104.8462992
      targetLocation: { lat: 15.24586046095168 , lng:104.84436797605323 }, //ubru happiness
      // 104.84584517605319,15.246034660947123, 15.246008,104.848400,15.2461282,104.8477836
      targetLocationSa: { lat:15.2461282 , lng: 104.8477836 }, // สวัสดิกการ
      distance: null,
      distanceSawat: null,
      isNear: false,
      swatNear: false,
      readMore:{},
    };
  },
  filters: {
    moment: function (date) {
      moment.locale("th");
      return moment(date).add(543, "year").format("LL");
    },
  },
  mounted() {
    
    this.getUserLocation();
    this.getSawatLocation();
    if (localStorage.getItem("auth") != null) {
      this.getorder();
      this.chk_auth = true;
      let c = JSON.parse(localStorage.getItem("auth"));
      this.code = c.std_code;
      // console.log(this.code, "std_code");
      this.orders = JSON.parse(localStorage.getItem("orders"));
      // console.log(this.orders, "setOrders");
      if (c.isLibraryStaff === 1) {
        this.staff = true;
      } else {
        this.staff = false;
      }
    }else{
      this.chk_auth =false;
    }

    if (localStorage.getItem("orders") != null) {
      this.loadOrder();
    }
  },
  methods: {
    // https://smartlibrary.ubru.ac.th/loan/borrow
    login(){
      this.$router.push("/login");
    },
    showMore(id) {
      this.$set(this.readMore, id, true);
      // if(id){
      //   this.readMore= true;
      // }
    },
    showLess(id) {
      this.$set(this.readMore, id, false);
    },
    getSawatLocation() {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          (position) => {
            this.sawatLocation = {
              lat: position.coords.latitude,
              lng: position.coords.longitude,
            };
            this.calculateDistanceSawat();
          },
          (error) => {
            console.error("Error getting user location", error);
          }
        );
      } else {
        alert("Geolocation is not supported by this browser.");
      }
    },
    calculateDistanceSawat() {
      if (this.sawatLocation && this.targetLocationSa) {
        const distance =
          getDistance(
            {
              latitude: this.sawatLocation.lat,
              longitude: this.sawatLocation.lng,
            },
            {
              latitude: this.targetLocationSa.lat,
              longitude: this.targetLocationSa.lng,
            }
          ) / 1000; // Convert to kilometers
        this.distanceSawat = distance.toFixed(2);
        this.swatNear = distance <= 0.07;
      }
    },

    // ubru libarary
    getUserLocation() {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          (position) => {
            this.userLocation = {
              lat: position.coords.latitude,
              lng: position.coords.longitude,
            };
            this.calculateDistance();
          },
          (error) => {
            console.error("Error getting user location", error);
          }
        );
      } else {
        alert("Geolocation is not supported by this browser.");
      }
    },
    calculateDistance() {
      if (this.userLocation && this.targetLocation) {
        const distance =
          getDistance(
            {
              latitude: this.userLocation.lat,
              longitude: this.userLocation.lng,
            },
            {
              latitude: this.targetLocation.lat,
              longitude: this.targetLocation.lng,
            }
          ) / 1000; // Convert to kilometers
        this.distance = distance.toFixed(2);
        this.isNear = distance <= 0.10;
      }
    },
    checkBarcode() {
      if (this.showBarcodeReturn === false) {
        this.showBarcodeReturn = true;
        // console.log("true");
      } else {
        this.showBarcodeReturn = false;
        // console.log("false");
      }
    },
    chang(text) {
      this.scanBarcode = text;
    },

    scanBarcode() {
      // console.log("scanning...");
    },
    return_enter() {
      // console.log('input borrow ===',this.inputsearch);
      let std;
      let acces = localStorage.getItem("access_token");
      let IP = localStorage.getItem("IP");
      // console.log("Access==", acces);

      let curdate = new Date();
      curdate.setUTCHours(curdate.getUTCHours() + 7);
      let timespit = curdate.toISOString().slice(0, 13).split("T");
      let objDate = {
        date: timespit[0],
        time: timespit[1],
      };

      this.keycomponent =
        "Bh3kiVe6KDRfcm9L4nNGm33pPF42PkhBB3Ft2GX7fcuvPQMh2YkTS3pV7JZMwCnIK"; //token+time;
      this.secret_one = this.keycomponent + objDate.date + " " + objDate.time;
      this.datas = {
        ciphertext: "",
        token:
          "Bh3kiVe6KDRfcm9L4nNGm33pPF42PkhBB3Ft2GX7fcuvPQMh2YkTS3pV7JZMwCnIK",
      };

      std = {
        token:
          "Bh3kiVe6KDRfcm9L4nNGm33pPF42PkhBB3Ft2GX7fcuvPQMh2YkTS3pV7JZMwCnIK",
        staff_code: this.code,
        access_token: acces,
        barcode: this.inputsearch,
        public_ip: IP,
      };

      // console.log(std, "STD == ");
      const headers = {
        "Content-Type": "application/json;charset=utf-8",
      };
      let ciphertext = this.encrypt_data(JSON.stringify(std), this.secret_one);
      axios
        .post("https://smartlibrary.ubru.ac.th/loan/return", ciphertext, {
          headers,
        })
        .then((res) => {
          // console.log( "data res == ",res);

          let data_res = res.data[0].data;
          let decrypt_one = this.decrypt_once(data_res, this.secret_one);
          // console.log(decrypt_one);

          let parse_json_decrypt_one = JSON.parse(decrypt_one);
          // console.log(parse_json_decrypt_one);

          // // localStorage.setItem('localToken', parse_json_decrypt_one.token);
          let decrypt_two = this.decrypt_once(
            parse_json_decrypt_one.ciphertext,
            this.secret_one
          );
          // console.log(decrypt_two,"decrypy two");

          let original_data = JSON.parse(decrypt_two);
          // console.log("original_db ", original_data);

          if (res.data[0].msg.status === 200) {
            this.data_loan = original_data.books;
            // console.log('data loan ==',this.data_loan);

            this.data_loan_arr.push(this.data_loan[0]);
            this.data_loan_object = this.data_loan_arr[0];
            // console.log(this.data_loan_arr);
            // console.log(this.data_loan_object);
            this.text_return = "";
          } else {
            this.text_return = "";
            // this.Error_verify(res[0].msg.message);
            alert(res.data[0].msg.message);
          }
        });
    },
    // onDecodeReturn(d) {
    //   this.text_return = d;
    //   if (this.id) clearTimeout(this.id);
    //   this.id = setTimeout(() => {
    //     if (this.text_return === d) {
    //       this.text_return = "";
    //     }
    //   }, 5000);
    //   if (this.text_return !== null || this.text_return !== "") {
    //     // console.log('return',this.text_return);

    //    // this.return_book();
    //   }
    // },
    // eslint-disable-next-line no-unused-vars
    onDecode(a, b, c) {
      // console.log(a, b, c);
      this.text = a;
      if (this.id) clearTimeout(this.id);
      this.id = setTimeout(() => {
        if (this.text === a) {
          this.text = "";
        }
      }, 5000);
      if (this.text !== null || this.text !== "") {
        this.boxTwo = "";
        this.$bvModal
          .msgBoxConfirm("บาร์โค้ด :" + this.text, {
            title: "คุณต้องการยืมหนังสือ",
            size: "sm",
            buttonSize: "sm",
            okVariant: "success",
            okTitle: "ยืนยัน",

            cancelTitle: "ยกเลิก",
            footerClass: "p-2",
            hideHeaderClose: false,
            centered: true,
          })
          .then((value) => {
            this.boxTwo = value;
            if (this.boxTwo === true) {
              this.return();
            }
            // console.log(this.boxTwo);
          })
          // eslint-disable-next-line no-unused-vars
          .catch((err) => {
            //  console.log(err);
            // An error occurred
          });

        // console.log('borrow');
        // this.borrow();
      }
    },
    onLoaded() {
      // console.log("load");
    },
    return() {
      let std;
      let acces = localStorage.getItem("access_token");
      let IP = localStorage.getItem("IP");
      // console.log("Access==", acces);

      let curdate = new Date();
      curdate.setUTCHours(curdate.getUTCHours() + 7);
      let timespit = curdate.toISOString().slice(0, 13).split("T");
      let objDate = {
        date: timespit[0],
        time: timespit[1],
      };

      this.keycomponent =
        "Bh3kiVe6KDRfcm9L4nNGm33pPF42PkhBB3Ft2GX7fcuvPQMh2YkTS3pV7JZMwCnIK"; //token+time;
      this.secret_one = this.keycomponent + objDate.date + " " + objDate.time;
      this.datas = {
        ciphertext: "",
        token:
          "Bh3kiVe6KDRfcm9L4nNGm33pPF42PkhBB3Ft2GX7fcuvPQMh2YkTS3pV7JZMwCnIK",
      };

      std = {
        token:
          "Bh3kiVe6KDRfcm9L4nNGm33pPF42PkhBB3Ft2GX7fcuvPQMh2YkTS3pV7JZMwCnIK",
        staff_code: this.code,
        access_token: acces,
        barcode: this.text,
        public_ip: IP,
      };

      // console.log(std, "STD == ");
      const headers = {
        "Content-Type": "application/json;charset=utf-8",
      };
      let ciphertext = this.encrypt_data(JSON.stringify(std), this.secret_one);
      axios
        .post("https://smartlibrary.ubru.ac.th/loan/return", ciphertext, {
          headers,
        })
        .then((res) => {
          // console.log( "data res == ",res);

          let data_res = res.data[0].data;
          let decrypt_one = this.decrypt_once(data_res, this.secret_one);
          // console.log(decrypt_one);

          let parse_json_decrypt_one = JSON.parse(decrypt_one);
          // console.log(parse_json_decrypt_one);

          // // localStorage.setItem('localToken', parse_json_decrypt_one.token);
          let decrypt_two = this.decrypt_once(
            parse_json_decrypt_one.ciphertext,
            this.secret_one
          );
          // console.log(decrypt_two,"decrypy two");

          let original_data = JSON.parse(decrypt_two);
          // console.log("original_db ", original_data);

          if (res.data[0].msg.status === 200) {
            this.data_loan = original_data.books;
            // console.log('data loan ==',this.data_loan);

            this.data_loan_arr.push(this.data_loan[0]);
            this.data_loan_object = this.data_loan_arr[0];
            // console.log(this.data_loan_arr);
            // console.log(this.data_loan_object);
            this.text = "";
          } else {
            this.text = "";
            // this.Error_verify(res[0].msg.message);
            alert(res.data[0].msg.message);
          }
        });
    },

    getorder() {
      let c = JSON.parse(localStorage.getItem("auth"));

      let data = {
        token: this.token,
        std_code: c.std_code,
      };
      // console.log(data, "data");

      const headers = {
        "content-type": "application/json",
      };

      axios
        .post("https://smartlibrary.ubru.ac.th/api/booking/getorder", data, {
          headers,
        })
        .then((res) => {
          // console.log("order welcome", res);
          if (res.data.msg.status === 200) {
            this.orders = res.data.Orders;
            // console.log(this.orders, "get order");
            localStorage.setItem("orders", JSON.stringify(this.orders));
          } else {
            // console.log(res.data.msg);
          }
        });
    },

    loadOrder() {
      this.orders = JSON.parse(localStorage.getItem("orders"));
    },
    encrypt_data(plaintext, secret) {
      let passphrase = CryptoJS.SHA384(this.secret_one).toString();
      let key = CryptoJS.enc.Utf8.parse(passphrase.substring(0, 32));
      this.datas.ciphertext = CryptoJS.AES.encrypt(plaintext, key, {
        iv: CryptoJS.enc.Utf8.parse(passphrase.substring(0, 16)),
        mode: CryptoJS.mode.ECB,
        passphrase: CryptoJS.pad.Pkcs7,
      }).toString();
      passphrase = "";
      return {
        data: this.encrypt_once(JSON.stringify(this.datas), secret).toString(),
      };
    },

    encrypt_once(plaintext, secret) {
      let passphrase = CryptoJS.SHA384(secret).toString();
      let key = CryptoJS.enc.Utf8.parse(passphrase.substring(0, 32));
      let ciptext = CryptoJS.AES.encrypt(JSON.stringify(plaintext), key, {
        iv: CryptoJS.enc.Utf8.parse(passphrase.substring(0, 16)),
        mode: CryptoJS.mode.ECB,
        passphrase: CryptoJS.pad.Pkcs7,
      }).toString();
      return ciptext;
    },

    decrypt_once(ciphertext, secret) {
      let passphrase = CryptoJS.SHA384(secret).toString();
      let key = CryptoJS.enc.Utf8.parse(passphrase.substring(0, 32));
      let bytes = CryptoJS.AES.decrypt(ciphertext, key, {
        iv: CryptoJS.enc.Utf8.parse(passphrase.substring(0, 16)),
        mode: CryptoJS.mode.ECB,
        passphrase: CryptoJS.pad.Pkcs7,
      });
      let decrypted = bytes.toString(CryptoJS.enc.Utf8);
      return decrypted;
    },
  },
};
</script>

<style lang="scss" scoped>
.web-camera-container {
  margin-top: 2rem;
  margin-bottom: 2rem;
  padding: 2rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border: 1px solid #ccc;
  border-radius: 4px;
  width: 500px;

  .camera-button {
    margin-bottom: 2rem;
  }

  .camera-box {
    .camera-shutter {
      opacity: 0;
      width: 450px;
      height: 337.5px;
      background-color: #fff;
      position: absolute;

      &.flash {
        opacity: 1;
      }
    }
  }

  .camera-shoot {
    margin: 1rem 0;

    button {
      height: 60px;
      width: 60px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 100%;

      img {
        height: 35px;
        object-fit: cover;
      }
    }
  }

  .camera-loading {
    overflow: hidden;
    height: 100%;
    position: absolute;
    width: 100%;
    min-height: 150px;
    margin: 3rem 0 0 -1.2rem;

    ul {
      height: 100%;
      position: absolute;
      width: 100%;
      z-index: 999999;
      margin: 0;
    }

    .loader-circle {
      display: block;
      height: 14px;
      margin: 0 auto;
      top: 50%;
      left: 100%;
      transform: translateY(-50%);
      transform: translateX(-50%);
      position: absolute;
      width: 100%;
      padding: 0;

      li {
        display: block;
        float: left;
        width: 10px;
        height: 10px;
        line-height: 10px;
        padding: 0;
        position: relative;
        margin: 0 0 0 4px;
        background: #999;
        animation: preload 1s infinite;
        top: -50%;
        border-radius: 100%;

        &:nth-child(2) {
          animation-delay: 0.2s;
        }

        &:nth-child(3) {
          animation-delay: 0.4s;
        }
      }
    }
  }

  @keyframes preload {
    0% {
      opacity: 1;
    }
    50% {
      opacity: 0.4;
    }
    100% {
      opacity: 1;
    }
  }
}
.home-section {
  position: relative;
  background: var(--greyLight-1);
  min-height: 100vh;
  top: 0;
  left: 78px;
  width: calc(100% - 78px);
  transition: all 0.5s ease;
  z-index: 2;
}
.sidebar.open ~ .home-section {
  left: 250px;
  width: calc(100% - 250px);
}
.home-section .text {
  display: inline-block;
  color: #11101d;
  font-size: 25px;
  font-weight: 500;
  margin: 18px;
}
/* */
.space {
  height: 50px;
}
/*btn*/
.btn__ {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  background-color: var(--btn-bg-return);
  color: var(--btn-color-return);
  padding: 14px 22px;
  border-radius: 8px;
  border: 0;
  cursor: pointer;
  font-weight: 600;
  font-size: 1rem;
  font-family: system-ui;
  border: 2px solid var(--btn-color-return);
  transition: 100ms ease;
  box-shadow: 5px 5px 0 0 var(--btn-color-return);
}

.btn__ :hover {
  box-shadow: 2px 2px 0 0 var(--btn-color-return);
}

.btn__ :active {
  transition: 50ms ease;
  box-shadow: 0 0 0 0 var(--btn-color-return);
}

.btn__ :focus-visible {
  outline: 0;
  --btn-color-return: #514440;
}

.btn__ :focus-visible::after {
  position: absolute;
  left: 50%;
  top: calc(100% + 12px);
  transform: translateX(-50%);
  content: "\21E7";
  animation: float 0.5s ease-in-out infinite;
}

@keyframes float {
  0% {
    transform: translateX(-50%) translatey(0px);
  }
  50% {
    transform: translateX(-50%) translatey(-6px);
  }
  100% {
    transform: translateX(-50%) translatey(0px);
  }
}

.btn-outline-purple {
  color: rgb(255, 95, 45);
  border-color: rgb(255, 95, 45);
}

.btn-outline-purple:hover {
  color: #fff;
  background-color: rgb(255, 95, 45);
  border-color: rgb(255, 95, 45);
}

.btn-outline-purple:focus,
.btn-outline-purple.focus {
  box-shadow: 0 0 0 0.2rem rgb(250, 129, 92);
}

.btn-outline-purple.disabled,
.btn-outline-purple:disabled {
  color: rgb(255, 95, 45);
  background-color: transparent;
}

.btn-outline-purple:not(:disabled):not(.disabled):active,
.btn-outline-purple:not(:disabled):not(.disabled).active,
.show > .btn-outline-purple.dropdown-toggle {
  color: #fff;
  background-color: rgb(255, 95, 45);
  border-color: rgb(255, 95, 45);
}

.btn-outline-purple:not(:disabled):not(.disabled):active:focus,
.btn-outline-purple:not(:disabled):not(.disabled).active:focus,
.show > .btn-outline-purple.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgb(250, 129, 92);
}
/*Overtime*/
.overtime {
  grid-column: 2/3;
  grid-row: 3/4;
  justify-self: center;
  width: 15rem;
  height: 3rem;
  border-radius: 1rem;
  box-shadow: inset 0.2rem 0.2rem 0.5rem var(--greyLight-2),
    inset -0.2rem -0.2rem 0.5rem var(--white);
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.overtime_icon {
  width: 3rem;
  height: 3rem;
  border-radius: 1rem;
  margin: 0 0 0 0.2rem;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1.5rem;
  color: orangered;
}
.overtime p {
  font-size: 1rem;
  margin-right: 4rem;
  margin-top: 1rem;
  color: var(--greyDark);
  font-weight: bold;
}
.overtime-detail {
  margin-bottom: 0px;
  margin-top: 0px;
}

/*END*/
/*image*/
.barcode {
  width: 100px;
  height: 100px;
}
/*card*/
.card-columns .card {
  border-radius: 10px;
}
.calendar-list .card {
  border-radius: 10px;
}
.card-content-more {
  position: relative;
  color: orangered;
  font-weight: bold;
}
.card-service {
  background-color: var(--greyLight-3);

  box-shadow: 0.8rem 0.8rem 1.4rem var(--greyLight-3),
    -0.2rem -0.2rem 1.8rem var(--white);
  background: none;
  font-family: inherit;
}

.card-scanbarcode {
  border: none;
  background-color: var(--greyLight-1);

  box-shadow: inset 0.2rem 0.2rem 0.5rem var(--greyLight-2),
    inset -0.2rem -0.2rem 0.5rem var(--white);
}
.card-title h1 {
  padding: 5px 5px;
  font-size: 2rem;
  font-weight: bold;
}
.card-title h4 {
  padding: 5px 20px;
  font-size: 0.5rem;
  font-weight: bold;
}
.card-title h5 {
  padding: 5px 20px;
  font-size: 0.8rem;
  font-weight: bold;
}
/* card */
@media (min-width: 768px) {
  .card-columns {
    column-count: 1;
  }

  .card-columns-left-item {
    column-count: 1;
  }
}

/* Large devices (desktops, 992px and up) */
@media (min-width: 992px) {
  .card-columns {
    column-count: 1;
  }

  .card-columns-left-item {
    column-count: 1;
  }
}

/* Extra large devices (large desktops, 1200px and up) */
@media (min-width: 1200px) {
  .card-columns {
    column-count: 1;
  }

  .card-columns-left-item {
    column-count: 2;
  }
}

@media (max-width: 667px) {
  .card-columns-left-item {
    column-count: 1;
  }
}
/*End*/

/*SEARCH */

.search {
  grid-column: 3/4;
  grid-row: 2/3;
  position: relative;
  display: flex;
  align-items: center;
}
.search__input {
  width: 100%;
  height: 3rem;
  border: none;
  border-radius: 1rem;
  font-size: 1.4rem;
  padding-left: 3.8rem;
  box-shadow: inset 0.2rem 0.2rem 0.5rem var(--greyLight-2),
    inset -0.2rem -0.2rem 0.5rem var(--white);
  background: none;
  font-family: inherit;
  /*color: var(--greyDark);*/
}
.search__input::-moz-placeholder {
  color: var(--greyLight-3);
}
.search__input:-ms-input-placeholder {
  color: var(--greyLight-3);
}
.search__input::placeholder {
  color: var(--greyLight-3);
}
.search__input:focus {
  outline: none;
  box-shadow: 0.3rem 0.3rem 0.6rem var(--greyLight-2),
    -0.2rem -0.2rem 0.5rem var(--white);
}
.search__input:focus + .search__icon {
  color: orangered;
}
.search__icon {
  height: 1.3rem;
  position: absolute;
  font-size: 1.5rem;
  padding: 0 1.5rem;
  display: flex;
  color: var(--greyDark);
  transition: 0.3s ease;
}
.card-body-menu {
  margin-top: 70px;
  font-family: "Kanit", sans-serif;
}
.card-title {
  text-align: center;
  font-family: "Kanit", sans-serif;
}
::placeholder {
  color: rgb(255, 255, 255);
}
.card-search {
  top: 20px;
  border: 0px solid;
  font-family: "Kanit", sans-serif;
}
/* END SEARCH*/

.wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  height: inherit;
}
/* red*/
.card_ {
  background: linear-gradient(to bottom left, #ef8d9c 40%, #ffc39e 100%);
  box-shadow: 5px 5px 20px rgba(var(--gray), 10%);
  min-width: 250px;
  border-radius: 15px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 40px 0;
  position: relative;
}

.card_ .img {
  width: 80px;
  height: 80px;
  background: #fff;
  border-radius: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.card_ .img img {
  width: 40px;
}

.card_ h1 {
  color: #fff;
  font-size: 20px;
  margin: 15px 0 6px 0;
}

.card_ small {
  color: rgba(255, 255, 255, 0.89);
  margin-bottom: 20px;
}
/*end*/
/*green*/
.card_isNear {
  background: linear-gradient(to bottom right, #b0db7d 40%, #99dbb4 100%);
  box-shadow: 5px 5px 20px rgba(var(--gray), 10%);
  min-width: 250px;
  border-radius: 15px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 40px 0;
  position: relative;
}

.card_isNear .img {
  width: 80px;
  height: 80px;
  background: #fff;
  border-radius: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.card_isNear .img img {
  width: 40px;
}

.card_isNear h1 {
  color: #fff;
  font-size: 20px;
  margin: 15px 0 6px 0;
}

.card_isNear small {
  color: rgba(255, 255, 255, 0.89);
  margin-bottom: 20px;
}
/*end*/

label {
  display: block;
  position: absolute;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  bottom: -18px;
}

label input {
  display: none;
}

label span {
  display: block;
  width: 40px;
  height: 40px;
  background: #fff;
  text-align: center;
  line-height: 40px;
  border-radius: 10px;
}

label span i {
  color: #f1777c;
  cursor: pointer;
  transition: all 200ms;
}

label .socialicon {
  background: #f1777c;
  min-width: 250px;
  height: 100px;
  position: absolute;
  bottom: -14px;
  border-radius: 12px;
  z-index: -1;
  transition: all 250ms cubic-bezier(0, 1.82, 0.58, 1);
}

label .socialicon ul {
  display: flex;
  height: 100%;
  justify-content: center;
  align-items: center;
  list-style: none;
}

label .socialicon ul li {
  width: 36px;
  height: 36px;
  background: #fff;
  margin: 0 10px;
  border-radius: 3px;
  cursor: pointer;
}

label .socialicon ul li a {
  text-decoration: none;
}

label .socialicon ul li a i {
  display: block;
  text-align: center;
  line-height: 36px;
  color: #f1777c;
}

label input:checked ~ span i {
  transform: rotate(182deg);
}

label input:checked ~ .socialicon {
  bottom: -110px;
  z-index: 99;
}
/*btn color */
.btn-orange {
  color: #fff;
  border-color: var(--sub-color);
  background-color: var(--orange-color);
}

.btn-orange:hover {
  color: #fff;
  border-color: var(--sub-color);
  background-color: var(--orange-color);
}
.btn-orange:focus,
.btn-orange.focus {
  color: #fff;
  border-color: var(--sub-color);
  background-color: var(--orange-color);
  box-shadow: 0 0 0 0.2rem rgba(180, 72, 112, 0.5);
}
.btn-orange.disabled,
.btn-orange:disabled {
  color: #fff;
  border-color: var(--sub-color);
  background-color: var(--orange-color);
}
.btn-orange:not(:disabled):not(.disabled):active,
.btn-orange:not(:disabled):not(.disabled).active,
.show > .btn-orange.dropdown-toggle {
  color: #fff;
  border-color: var(--sub-color);
  background-color: var(--sub-color);
}
.btn-orange:not(:disabled):not(.disabled):active:focus,
.btn-orange:not(:disabled):not(.disabled).active:focus,
.show > .btn-orange.dropdown-toggle:focus {
  /*rgba(180, 72, 112, 0.5);*/
  box-shadow: 0 0 0 0.2rem rgba(255, 109, 65, 0.468);
}
</style>
